import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Typography } from '@emburse/ui-core';
export const TestSiteBanner = () => {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.FEATURES) === null || _a === void 0 ? void 0 : _a.test_site) {
        return (_jsx(Typography, Object.assign({ variant: "h6", style: { color: 'red' }, gutterBottom: true }, { children: "THIS IS A TEST WEBSITE. PLEASE DON'T USE YOUR REAL CREDENTIALS TO LOGIN" })));
    }
    return null;
};
